<script>
import Layout from '@layouts/main'
import { cdmMethods } from '@state/helpers'
import _ from 'lodash'
import FilterPanel from '@components/filter-panel'

export default {
  metaInfo: {
    title: 'Cdms',
    meta: [{ name: 'description', content: 'Cdms' }],
  },
  components: {
    Layout,
    FilterPanel,
  },
  props: {
    fields: {
      type: Array,
      required: true,
    },
    approvalWorkflows: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      search: '',
      loadingError: null,
      loading: true,
      isWorking: false,
      createError: null,
      pagination: {
        rowsPerPage: 25,
      },
      items: [],
      actionItems: ['a', 'b', 'c'],
      totalData: 0,
      filterExpanded: false,
      selectedTasks: [],
    }
  },
  computed: {
    sortedActiveFields() {
      var fields = this.fields.filter(
        x => x.showInTable === true || x.uniqueIdentifier === true
      )
      return fields.sort(function(a, b) {
        return a.order - b.order
      })
    },
    headers() {
      return this.sortedActiveFields.map(field => {
        return { text: field.caption || field.name, value: field.name }
      })
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      },
      deep: true,
    },
    search: {
      handler() {
        this.getDataFromApi()
      },
    },
  },
  created() {
    this.getDataFromApi = _.debounce(this.getDataFromApi, 500)
  },
  methods: {
    ...cdmMethods,
    cptUrlForCode(code) {
      return `https://coder.aapc.com/search/?keyword=${code}`
    },

    // Route to CDM view
    goToCdm(cdm) {
      this.$router.push({ name: 'viewCdm', params: { cdmId: cdm.CMNIdField } })
    },
    recordIsActive(field, record) {
      const inactive = '#c3c3c3'
      const active = 'green'
      if (!field.format) {
        return inactive
      }

      var components = field.format.split(',')
      if (components.length !== 2) {
        return inactive
      }

      var activeValue = components[0]

      return record[field.name] === activeValue ? active : inactive
    },
    getDataFromApi() {
      this.loading = true
      var vm = this
      return this.getOnlyCdms({
        force: true,
        queryTerms: { ...this.pagination, filter: this.search },
      })
        .then(data => {
          vm.loading = false

          vm.totalData = data.totalCount
          vm.items = data.results
        })
        .catch(error => {
          vm.loading = false
          vm.loadingError = error
        })
    },
    onFilterExpandChanged(val) {
      this.filterExpanded = val
    },
  },
}
</script>

<template>
  <Layout>
    <!-- NEW -->
    <v-container fluid grid-list-md ma-0>
      <!-- Header -->
      <v-layout row align-center justify-space-between>
        <h3>CDM</h3>
        <base-link>
          <img
            src="/assets/icon-export.svg"
            :class="$style.export"
            alt="Export"
          />
          Export All
        </base-link>
      </v-layout>

      <v-layout row>
        <v-card
          :class="
            filterExpanded
              ? $style.tableCardOpenFilters
              : $style.tableCardClosedFilters
          "
        >
          <v-card-title>
            <v-layout>
              <v-flex md7>
                <v-layout align-center>
                  <v-flex md2 class="pt-3 pl-3"># selected</v-flex>

                  <v-flex align-self-start md5>
                    <v-select
                      :class="$style.actions"
                      :items="actionItems"
                      class="ml-3 mr-5"
                      color="cyan"
                      label="Choose Action"
                      hide-details
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex md3>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  color="cyan"
                  label="Search"
                  hide-details
                  single-line
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :pagination.sync="pagination"
            :total-items="totalData"
            class="elevation-1"
            select-all
          >
            <v-progress-linear
              slot="progress"
              color="cyan"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-model="selectedTasks"
                  :value="props.item"
                  color="cyan"
                  hide-details
                />
              </td>
              <td
                v-for="field in sortedActiveFields"
                :key="field.id"
                @click="
                  if (!field.procedureCode) {
                    goToCdm(props.item)
                  }
                "
              >
                <div v-if="field.procedureCode">
                  <a
                    target="_blank"
                    :href="cptUrlForCode(props.item[field.name])"
                    >{{ props.item[field.name] }}</a
                  >
                </div>
                <!-- Active dot -->
                <div v-else-if="field.activeInactive">
                  <v-icon
                    size="x-small"
                    :color="recordIsActive(field, props.item)"
                    >mdi-circle</v-icon
                  >
                </div>
                <div v-else>{{ props.item[field.name] }}</div>
              </td>
            </template>
          </v-data-table>
        </v-card>

        <FilterPanel
          :is-expanded="filterExpanded"
          @filterExpandChanged="onFilterExpandChanged"
        />
      </v-layout>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.tableCardOpenFilters {
  width: 75%;
}

.tableCardClosedFilters {
  width: calc(100% - 50px);
}

.export {
  margin-right: 3px;
  vertical-align: sub;
}

.tableCard {
  width: calc(100% - 300px);
}
</style>
